import React from "react";

const Loader = ({ message = "Loading Luxury Collection..." }) => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <div className="loader-circle">
          <div className="spinner"></div>
        </div>
        <p className="loader-text">{message}</p>
      </div>
    </div>
  );
};

export default Loader;
